import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'

import { Link } from 'base-ui'

import { useOpenableControls } from '../../../../../../generic-hooks'
import {
  getFormattedPromotionDiscountedAmountOrPercentage,
  ProductSellerVoucherLabelDiscountDialog,
} from '../../../../../../product'

export const ProductBuyBoxVoucherInfoSellerDiscountDescription: FC<{
  sellerPromotion: SellerPromotionV2
}> = ({ sellerPromotion }) => {
  const modalControls = useOpenableControls()
  const intl = useIntl()

  return (
    <>
      <ProductSellerVoucherLabelDiscountDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
        sellerPromotion={sellerPromotion}
      />
      <p className="text-s font-normal text-dark-primary-max">
        <FormattedMessage
          id="seller.promotion.product.discountCardDescription"
          values={{
            discountValue: getFormattedPromotionDiscountedAmountOrPercentage(
              sellerPromotion,
              intl,
            ),
          }}
        />{' '}
        <Link
          className="underline"
          color="inherit"
          data-qa-id="product-buybox-voucher-more-details-button"
          onClick={modalControls.handleOpen}
          slots={{ root: 'button' }}
          type="button"
        >
          <FormattedMessage id="general.more.details.short" />
        </Link>
      </p>
    </>
  )
}
